import React, {useState, useEffect} from 'react'
import {Checkbox} from '@salesforce/design-system-react'

const CustomCheckbox = ({id, label, checked, onUpdate}) => {
  const [checkedInput, setCheckedInput] = useState(checked)

  useEffect(() => {
    onUpdate(label, checkedInput)
  }, [checkedInput])

  return (
    <div className="slds-p-top_x-small form-item-full">
      <Checkbox
        id={id}
        labels={{
          label: label,
        }}
        checked={checkedInput}
        onChange={(e) => {
          console.log('onChange ', e.target)
          setCheckedInput(!checkedInput)
        }}
      />
    </div>
  )
}

CustomCheckbox.defaultProps = {
  onUpdate: () => console.log('ATTACH FORM UPDATE FUNCTION')
}

export default CustomCheckbox
